import Vue from "vue"
import Vuex from "vuex"
import VuexPersistence from "vuex-persist"
import user from "./modules/user"
import display from "./modules/display"
import schemas from "./modules/schemas"
import Cropper from "cropperjs"

import api from "@/services/api"

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => ({
    user: state.user,
    display: state.display,
    schemas: state.schemas
  })
})

// initial state
const state = {
  error: "",
  errorTimeout: function() {},
  success: "",
  errorTimeout: function() {},
  new_password: false,
  userAttributes: {},
  showCropModal: false,
  imagetocrop: {},
  cropObj: {},
  cropProp: "",
  cropper: {},
  customisations: null,
  promises: []
}

const getters = {
  showOn: state => (page, show_on, hide_on) => {
    if (state.customisations.site_id == "pivot" || state.customisations.site_id == "wortleybros") {
      if (show_on) if (!Array.isArray(show_on)) show_on = [show_on]
      if (hide_on) if (!Array.isArray(hide_on)) hide_on = [hide_on]

      var show = true
      if (show_on) show = show_on.some(elem => elem.values.includes(page[elem.attribute]))
      if (show && hide_on) show = !hide_on.some(elem => elem.values.includes(page[elem.attribute]))

      return show
    } else {
      if (show_on) {
        if (!Array.isArray(show_on)) show_on = [show_on]
        return show_on.some(elem => elem.values.includes(page[elem.attribute]))
      }

      if (hide_on) {
        if (!Array.isArray(hide_on)) hide_on = [hide_on]
        return !hide_on.some(elem => elem.values.includes(page[elem.attribute]))
      }

      return true
    }
  },
  customisations: state => {
    return state.customisations
  }
}

const mutations = {
  setImageToCrop: (state, payload) => {
    state.showCropModal = true
    state.imagetocrop = payload.image
    state.cropObj = payload.obj
    state.cropProp = payload.prop
  },
  clearImageToCrop: (state, payload) => {
    state.showCropModal = false
    state.imagetocrop = {}
  },
  addPromise: (state, payload) => {
    state.promises.push(payload)
  },
  clearPromises: (state, payload) => {
    state.promises = []
  },
  setCustomisations: (state, payload) => {
    state.customisations = payload
  },
  setCropper: (state, payload) => {
    state.cropper = {}
    var image = document.getElementById("crop-image")
    state.cropper = new Cropper(image, {
      checkCrossOrigin: false,
      viewMode: 1,
      autoCropArea: 1,
      dragMode: "move",
      aspectRatio: payload.width / payload.height,
      background: false,
      cropBoxResizable: false
    })
  },
  NEW_PASSWORD_REQUIRED: (state, payload) => {
    state.new_password = true
    state.userAttributes = payload
  },
  CLEAR_NEW_PASSWORD: state => (state.new_password = false)
}

const actions = {
  setError({ state }, payload) {
    clearTimeout(state.errorTimeout)
    state.error = payload.message
    state.errorTimeout = setTimeout(() => {
      state.error = ""
    }, 3000)
  },
  setSuccess({ state }, payload) {
    clearTimeout(state.successTimeout)
    state.success = payload.message
    state.successTimeout = setTimeout(() => {
      state.success = ""
    }, 3000)
  },
  getCustomisations({ commit, state }) {
    return new Promise(resolve => {
      if (!state.customisations)
        api.getCustomisations().then(customisations => {
          commit("setCustomisations", customisations)
          resolve()
        })
      else resolve()
    })
  }
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: { user, display, schemas },
  plugins: [vuexLocal.plugin]
})
